module.exports = __webpack_public_path__ + "media/images/tiedye/design-7-4bb4377b5e79417e9fda89afd4ad5029.jpg";